import React from 'react';
import Hero from './components/IQAC/notifications/Hero';
import Main from './components/IQAC/notifications/Main';

const IqacNotifications = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacNotifications;